import React from 'react';
import { CONTACT } from '../constants';
import { useLang } from '../context/LanguageContext';
import { t } from '../translations';

const Header = () => {
  const { lang, toggle } = useLang();
  const tx = t[lang];
  const waLink = `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(CONTACT.whatsappMessage)}`;

  return (
    <header className="bg-white border border-zinc-200 rounded-lg p-6 md:p-8">
      {/* Language switch */}
      <div className="flex justify-end mb-4 no-print">
        <button
          onClick={toggle}
          className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium border border-zinc-300 rounded-md text-zinc-600 hover:bg-zinc-50 transition-colors"
        >
          <span>{lang === 'es' ? '🇺🇸' : '🇦🇷'}</span>
          <span>{lang === 'es' ? 'English' : 'Español'}</span>
        </button>
      </div>

      <div className="flex flex-col md:flex-row justify-between items-start gap-6">
        <div className="flex-grow">
          <h1 className="text-3xl md:text-4xl font-bold text-zinc-900 tracking-tight mb-1">
            {CONTACT.name}
          </h1>
          <p className="text-base text-zinc-700 mb-1">{tx.role}</p>
          <p className="mono text-xs text-zinc-500 mb-5">{tx.stack}</p>

          <p className="text-sm text-zinc-600 mb-5">{CONTACT.location}</p>

          <div className="flex flex-wrap gap-2 no-print">
            <a
              href={waLink}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 px-3.5 py-2 bg-zinc-900 text-white text-sm font-medium rounded-md hover:bg-zinc-800 transition-colors"
            >
              WhatsApp
            </a>
            <a
              href={`mailto:${CONTACT.email}`}
              className="inline-flex items-center gap-2 px-3.5 py-2 bg-white border border-zinc-300 text-zinc-800 text-sm font-medium rounded-md hover:bg-zinc-50 transition-colors"
            >
              Email
            </a>
            <a
              href={CONTACT.linkedin}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 px-3.5 py-2 bg-white border border-zinc-300 text-zinc-800 text-sm font-medium rounded-md hover:bg-zinc-50 transition-colors"
            >
              LinkedIn
            </a>
          </div>
        </div>

        <div className="w-28 h-28 md:w-32 md:h-32 flex-shrink-0">
          <img
            src="/profile.jpg"
            alt="Dante Milano"
            className="w-full h-full object-cover rounded-md"
          />
        </div>
      </div>
    </header>
  );
};

export default Header;
